import React from 'react';
import get from 'lodash/get';

const SellingPriceFormatter = (props) => {
  if (!props.dependentValues.rowData) return <div />;

  let value = '';
  let key = props.column.key;
  key = key.substring(0, key.indexOf(']') + 1);
  const sellingPrice = get(props.dependentValues.rowData, key);
  if (sellingPrice) {
    value = sellingPrice.salesPrice;
  }
  return <div>{value}</div>;
};

export default SellingPriceFormatter;
